module.exports = __webpack_public_path__ + "img/media3.e360d97f.png";